module.exports = __webpack_public_path__ + "img/hopways-03.f19be90c.jpeg";